<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="tech-offer-side flex flex-col items-center">
        <h3>Your work starts here with us!</h3>
        <img src="@/assets/image/consultant_accept.png" alt="interview" />
        <div class="tech-offer-steps">
          <div class="flex">
            <div class="tech-step-order">
              <span>1</span>
            </div>
            <div class="tech-step-info flex-1">Sign up for interview</div>
          </div>
          <div class="flex">
            <div class="tech-step-order">
              <span>2</span>
            </div>
            <div class="tech-step-info flex-1">We make your a offer</div>
          </div>
          <div class="flex active">
            <div class="tech-step-order">
              <span>3</span>
            </div>
            <div
              class="tech-step-info flex-1"
            >You can accept offer to be a active consultant with us!</div>
          </div>
        </div>
      </div>
      <div class="tech-offer-main flex-1">
        <h3>Thank you for accepting your offer!</h3>
        <p v-if="submitSuccess">Submit sucess!</p>
        <div v-if="!submitSuccess">
          <p>Depending on what we think you are a fit for, we'll either bring you into our slack for ad hoc work or full-time opportunities you can agree or disagree to.</p>
          <p>Note that this is not a full-time job that we're signing you up for, just establishing a relationship where we can bring you gigs/jobs you might be interested in. And also showing you to our clients.</p>
          <p>We just need some last information to get started:</p>
          <p>
            <span
              class="strong"
            >ID/Work permit:(If you are a US citizen, upload your drive license or passport, else upload your work permit and ID)</span>
          </p>
          <div class="form-inline" v-for="(item, index) in workPermits" :key="'workPermit' + index">
            <div class="input-group">
              <div class="input-file" style="width: calc(100% - 50px);">
                <input
                  id="license"
                  type="file"
                  placeholder="image"
                  @change="onUploadWorkPermit(index, $event)"
                />
                <label
                  class="custom-file-label"
                  for="license"
                >{{item.name ? item.name : "Choose file"}}</label>
              </div>
              <a
                href="javascript:void(0)"
                class="input-apend-btn"
                style="right: 20px;"
                @click="deleteWorkPermit(index)"
              >
                <i class="material-icons-outlined align-middle">delete</i>
              </a>
              <a href="javascript:void(0)" class="input-apend-btn" @click="addWorkPermit(index)">
                <i class="material-icons-outlined align-middle">add</i>
              </a>
            </div>
          </div>
          <p>
            <span class="strong">Upload any certification you have and mentioned in your resume:</span>
          </p>
          <div
            class="form-inline"
            v-for="(item, index) in certifications"
            :key="'certification' + index"
          >
            <div class="input-group">
              <div class="input-file" style="width: calc(100% - 50px);">
                <input
                  id="cert"
                  type="file"
                  placeholder="image"
                  @change="onUploadCertification(index, $event)"
                />
                <label
                  class="custom-file-label"
                  for="cert"
                >{{item.name ? item.name : "Choose file"}}</label>
              </div>
              <a
                href="javascript:void(0)"
                class="input-apend-btn"
                style="right: 20px;"
                @click="deleteCertification(index)"
              >
                <i class="material-icons-outlined align-middle">delete</i>
              </a>
              <a href="javascript:void(0)" class="input-apend-btn" @click="addCertification(index)">
                <i class="material-icons-outlined align-middle">add</i>
              </a>
            </div>
          </div>
          <p>
            <span class="strong">You will be assigned a "tier" or "level" in IT support that you will be cleared for. Each "level" of work has an associated pay rate. Are you willing to do work that is below your skill level, even though the pay rate would be lower?</span>
          </p>
          <div class="accept-radio-wrapper">
            <div class="accept-radio-item">
              <input type="radio" id="questionOne1" v-model="skillLevel"
                name="qustionOne" value="No, only notify me of work that is within my skill level">
              <label for="questionOne1">No, only notify me of work that is within my skill level</label>
            </div>
            <div class="accept-radio-item">
              <input type="radio" id="questionOne2" v-model="skillLevel"
                name="qustionOne" value="Yes, but only work that is one level below me">
              <label for="questionOne2">Yes, but only work that is one level below me</label>
            </div>
            <div class="accept-radio-item">
              <input type="radio" id="questionOne3" v-model="skillLevel"
                name="qustionOne" value='Yes, please notify me of any work, even if it is 2+ levels below my clearance "tier"'>
              <label for="questionOne3">Yes, please notify me of any work, even if it is 2+ levels below my clearance "tier"</label>
            </div>
          </div>
          <p>
            <span class="strong">What is your current work situation?</span>
          </p>
          <div class="accept-radio-wrapper">
            <div class="accept-radio-item">
              <input type="radio" id="questionTwo1" v-model="workSituation"
                name="questionTwo" value="Unemployed">
              <label for="questionTwo1">Unemployed</label>
            </div>
            <div class="accept-radio-item">
              <input type="radio" id="questionTwo2" v-model="workSituation"
                name="questionTwo" value="I have a part time job">
              <label for="questionTwo2">I have a part time job</label>
            </div>
            <div class="accept-radio-item">
              <input type="radio" id="questionTwo3" v-model="workSituation"
                name="questionTwo" value="I have a full time job">
              <label for="questionTwo3">I have a full time job</label>
            </div>
          </div>
          <p>
            <span class="strong">What type of work are you open to out of the options: full time, part time, and/or short term projects (ad hoc work)? Multiple is ok.</span>
          </p>
          <div class="accept-radio-wrapper">
            <div class="accept-radio-item">
              <input type="checkbox" id="questionThree1"
                value="Full time" v-model="workType1">
              <label for="questionThree1">Full time</label>
            </div>
            <div class="accept-radio-item">
              <input type="checkbox" id="questionThree2"
                value="Part time" v-model="workType2">
              <label for="questionThree2">Part time</label>
            </div>
            <div class="accept-radio-item">
              <input type="checkbox" id="questionThree3"
                value="Short term projects (ad hoc)" v-model="workType3">
              <label for="questionThree3">Short term projects (ad hoc)</label>
            </div>
          </div>
          <p>
            <span class="strong">What general geographic area are you willing to drive to, to work onsite, without relocating? (please describe specifically using the text below)</span>
          </p>
          <div class="form-inline">
            <input v-model="geographic" />
          </div>
          <p>
            <span class="strong">Put 2 references who have worked with you around a year or longer</span>
          </p>
          <div class="form-inline">
            <div>
              <textarea
                name="references"
                id="references"
                rows="5"
                placeholder="If you can please put 1-2 references; We need a business email and phone number if possible and also a short description of how you worked together. Feel free to skip this for now we can also get it later in the process"
                v-model="references"
              />
            </div>
          </div>
          <div class="form-inline tech-offer-btn">
            <!-- <button class="submit primary" @click="submit">SUBMIT INFO</button> -->
            <spinnerButton
              class="submit primary"
              :loading="submitLoading"
              @click.native="submit"
            >SUBMIT INFO</spinnerButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as firebase from "@/vendor/firebase";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  data() {
    return {
      submitSuccess: false,
      references: null,
      workPermits: [{}],
      certifications: [{}],
      submitLoading: false,
      skillLevel: null,
      workSituation: null,
      workType1: null,
      workType2: null,
      workType3: null,
      geographic: null
    };
  },
  computed: {
    ...mapState(["user"])
  },
  components: {
    spinnerButton
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
  },
  methods: {
    addWorkPermit: function(index) {
      this.workPermits.splice(index + 1, 0, {});
    },
    deleteWorkPermit: function(index) {
      this.workPermits.splice(index, 1);
      if (this.workPermits.length == 0) {
        this.workPermits.push({});
      }
    },
    onUploadWorkPermit: function(index, event) {
      const file = event.target.files[0];
      this.$set(this.workPermits[index], "name", file.name);
      this.$set(this.workPermits[index], "file", file);
    },
    addCertification: function(index) {
      this.certifications.splice(index + 1, 0, {});
    },
    deleteCertification: function(index) {
      this.certifications.splice(index, 1);
      if (this.certifications.length == 0) {
        this.certifications.push({});
      }
    },
    onUploadCertification: function(index, event) {
      const file = event.target.files[0];
      this.$set(this.certifications[index], "name", file.name);
      this.$set(this.certifications[index], "file", file);
    },
    submit: async function() {
      const id = this.user.consultant.id;
      if (!id) {
        this.$toasted.global.toast_error({ message: "user not found" });
        return;
      }
      const data = {};
      if (!this.skillLevel) {
        this.$toasted.global.toast_error({ message: "please finish questions" });
        return
      }
      data.skillLevel = this.skillLevel;
      if (!this.workSituation) {
        this.$toasted.global.toast_error({ message: "please finish questions" });
        return
      }
      data.workSituation = this.workSituation;
      if (!this.workType1 && !this.workType2 && !this.workType3) {
        this.$toasted.global.toast_error({ message: "please finish questions" });
        return
      }
      this.submitLoading = true;
      data.workTypes = [];
      if (this.workType1) data.workTypes.push("Full time");
      if (this.workType2) data.workTypes.push("Part time");
      if (this.workType3) data.workTypes.push("Short term projects (ad hoc)");
      if (!this.geographic) {
        this.$toasted.global.toast_error({ message: "please finish questions" });
        return
      }
      data.geographic = this.geographic;
      const workPermits = [];
      for (const i in this.workPermits) {
        const item = this.workPermits[i];
        if (item.name && item.file) {
          const result = await firebase.storagePut(
            `consultants/${id}/`,
            "work_id_" + item.name,
            item.file
          );
          if (result.ok) {
            workPermits.push("work_id_" + item.name);
          }
        }
      }
      if (workPermits.length == 0) {
        this.$toasted.global.toast_error({
          message: "please upload your ID/work permit"
        });
        this.submitLoading = false;
        return;
      }
      const certifications = [];
      for (const i in this.certifications) {
        const item = this.certifications[i];
        if (item.name && item.file) {
          const result = await firebase.storagePut(
            `consultants/${id}/`,
            "certification_" + item.name,
            item.file
          );
          if (result.ok) {
            certifications.push("certification_" + item.name);
          }
        }
      }
      if (workPermits.length > 0) data.workPermits = workPermits;
      if (certifications.length > 0) data.certifications = certifications;
      if (this.references) data.references = this.references;
      firebase.db
        .collection("consultants")
        .doc(id)
        .update({
          is_active: true,
          application_data: data,
          application_status: null
        })
        .then(() => {
          this.submitSuccess = true;
          this.$toasted.global.toast_success({ message: "submit success" });
          this.user.consultant = {
            id: id
          };
          this.$router.push("/home/consultant/consultant_dashboard?id=" + id);
        })
        .catch(error => {
          this.$toasted.global.toast_error({ message: "submit error" });
        })
        .finally(() => {
          this.submitLoading = true;
        });
    }
  }
};
</script>
